'use client';

import type { User } from 'next-auth';
import { useRouter, usePathname } from 'next/navigation';

import { PlusIcon } from '@/components/icons';
import { SidebarHistory } from '@/components/sidebar-history';
import { SidebarUserNav } from '@/components/sidebar-user-nav_new';
import { Button } from '@/components/ui/button';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  useSidebar,
} from '@/components/ui/sidebar';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import Link from 'next/link';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Command } from 'cmdk' 
import { CMDKWrapper, Item } from "@/components/ui/raycast";
import useGlobalStore from "@/stores/global-store";
import { useWindowSize } from "usehooks-ts";
import { FlowStage } from "./left-data/novel.type";
import { useDebouncedCallback } from "use-debounce";
import { Checkbox, CheckboxFancy } from "@/components/zustom/check-box";

import { ChevronDown, ChevronRight, Search, History, Flower2 } from "lucide-react";
import { cn, isEn } from "@/lib/utils";

import { useEffect, useMemo, useRef, useState } from 'react';
import { SidebarLinkNoHref } from '@/components/aceternity/sidebar';
import { IconArrowRight, IconMenu2 } from '@tabler/icons-react';
import { ChatFlowNavSelector, DefaultNavLink, SettingNavLink, FloatingActionAddChat } from '@/components/custom/chat-flow-nav-selector';

// import {  novel as DOCS } from "@/app/(work)/layout-left/left-data/novel.novel";
// import {  guidance } from "@/app/(work)/layout-left/left-data/auto.guidance";
// import {  work } from "@/app/(work)/layout-left/left-data/auto.work";
// import {  brief } from "@/app/(work)/layout-left/left-data/novel.brief";
// import {  media } from "@/app/(work)/layout-left/left-data/novel.media";
// import {  film } from "@/app/(work)/layout-left/left-data/novel.film";
// import {  xiaohongshu } from "@/app/(work)/layout-left/left-data/novel.xiaohongshu-deepseek";
// import {  duanshiping } from "@/app/(work)/layout-left/left-data/media.duanshiping-deepseek";
// import {  toutiao } from "@/app/(work)/layout-left/left-data/media.toutiao-deepseek";
// import {  gongzhonghao } from "@/app/(work)/layout-left/left-data/media.gongzhonghao-deepseek";
// import {  test1 } from "@/app/(work)/layout-left/left-data/novel.test";
import { getWorkflowData } from '@/app/(work)/layout-left/flow-data/flow-phase';
import useTemplateStore from '@/stores/templateStore';
import { sslog } from '@/lib/utils/sslog';
import { KEY_FlowTemplateFlag } from '@/lib/constants';
import { NavLink } from '@/lib/type';

export function WorkSidebar({ user }: { user: User | undefined }) {
  const router = useRouter();
  const { spaceTag, setSpaceTag, openMobile ,setOpenMobile } = useSidebar();


 // const router = useRouter();
  // const { setPath } = useSidebar();
  const { width: windowWidth, height: windowHeight } = useWindowSize();
  const isMobile = windowWidth ? windowWidth < 768 : false;
  const { setFlowTemplateName } = useTemplateStore();
  const { llog, setUser, processEnv, mouseOverPath, selectedPath, selectedChat, activeToolItem, currentLink, setCurrentLink, setMouseOverPath, setSelectedPath, setToolActionName, setActiveToolItem, setWorkflow} = useGlobalStore();
  const [selectPath, setSelectPath] = useState('')
  const [selectDocs, setSelectDocs] = useState<FlowStage[]>([])
  
  const [sideMode, setSideMode] = useState<'Step' | 'Nav'>('Nav')
  const [value, setValue] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const inputRef = useRef<HTMLInputElement | null>(null)
  const listRef = useRef(null)
  const [open, setOpen] = useState(true);
  const [animate, setAnimate] = useState(false);

  const pathname = usePathname();
  const [searchTerm, setSearchTerm] = useState("");
  const [openGroups, setOpenGroups] = useState<string[]>([]);// (guidance.map((group) => group.phaseKey));
  const [selectedGroup, setSelectedGroup] = useState<FlowStage | undefined>();

  const [showCurrentLink, setShowCurrentLink] = useState<NavLink | null>(null);//DefaultNavLink.href);
  const memoDocs2: any[] = [];

  sslog('preFirst limk.log tool sidebar mouseOverPath, activeToolItem:', {mouseOverPath, activeToolItem, processEnv});

  const memoData:{docs: FlowStage[], workflow: string}  = useMemo(() => {
    // 在组件中使用
    let docs: FlowStage[] = [];
    let data: {docs: FlowStage[], workflow: string} = {docs, workflow:'' }

    if (mouseOverPath === '#history') { return data}
    
    if (mouseOverPath) {
      data = getWorkflowData(mouseOverPath);
      setTimeout(() => {
        setWorkflow(data.workflow);
      }, 3000);
    }
    
    // if (mouseOverPath === 'novel') return DOCS;
    // if ('#guidance' === mouseOverPath) docs = guidance; 

    // if ('#work' === mouseOverPath) docs = work; 
    // if (mouseOverPath === '#brief') docs = brief; 
    // if (mouseOverPath=== '#media') docs = media; 
    // if (mouseOverPath=== '#film') docs = film; 
    // if (mouseOverPath === '#guidance') docs = test1; 
    // if (mouseOverPath=== '#xiaohongshu') docs = xiaohongshu; 
    // if (mouseOverPath=== '#gongzhonghao') docs = gongzhonghao; 
    // if (mouseOverPath=== '#toutiao') docs = toutiao; 
    // if (mouseOverPath=== '#duanshiping') docs = duanshiping; 

    // console.log(`limk.log tool sidebar useMemo mouseOverPath: ${mouseOverPath} - docs:` + JSON.stringify(docs) );
    
    // if(!isMobile) {
    //   setOpen(true);
    //   setAnimate(true);
    // }
    // const activeGroup = docs.find((group) =>
    //   group.phaseTasks.some((child) => child.url === pathname)
    // );
    // if (activeGroup && !openGroups.includes(activeGroup.phaseKey)) {
    //   setOpenGroups((prev) => [...prev, activeGroup.phaseKey]);
    // }
    
    return data;
  }, [mouseOverPath]);

  useEffect(() => {
    user && setUser(user);
    // llog('limk.log tool sidebar search value:' + value);
  }, [user]);

  useEffect(() => {
    // llog('limk.log tool sidebar search value:' + value);
    setShowCurrentLink(currentLink);
  }, [currentLink]);

  // useEffect(() => { // limk.mark 在memo中实现
  //   llog('limk.log tool sidebar mouseOverPath:' + mouseOverPath);
  //   if(!isMobile) {
  //     setOpen(true);
  //     setAnimate(true);
  //   }

  //   const activeGroup = memoDocs.find((group:any) =>
  //     group.phaseTasks.some((child:any) => child.url === pathname)
  //   );
  //   if (activeGroup && !openGroups.includes(activeGroup.phaseKey)) {
  //     setOpenGroups((prev) => [...prev, activeGroup.phaseKey]);
  //   }

  // }, [mouseOverPath]); 

  // useEffect(() => {
  //   // llog('limk.log tool sidebar selectedPath:' + selectedPath);
  //   console.log('limk.log tool sidebar selectedPath changed:' + selectedPath);

  //   if (selectedPath && selectedPath.length > 0 && selectedPath !== '#work'){
  //     setOpen(true);
  //     setAnimate(true);
  //   }

  // }, [selectedPath]);

  useEffect(() => {
    // llog('limk.log tool sidebar selectedChat:' + selectedChat);
    setOpen(openMobile);
    setAnimate(openMobile);
  }, [openMobile]);

  useEffect(() => {
    sslog('limk.log tool sidebar selectedChat:', selectedChat);
    setOpen(true);
    setAnimate(false);
  }, [selectedChat]);
  
  
  // useEffect(() => {
  //   // Ensure the group of the active link is open
  //   const activeGroup = DOCS.find((group) =>
  //     group.phaseTasks.some((child) => child.url === pathname)
  //   );
  //   if (activeGroup && !openGroups.includes(activeGroup.phaseKey)) {
  //     setOpenGroups((prev) => [...prev, activeGroup.phaseKey]);
  //   }

  //   // llog('limk.log tool sidebar pathname:' + pathname);
  // }, [pathname]);

  const toggleGroup = (phaseKey: string) => {
    setOpenGroups((prev) =>
      prev.includes(phaseKey)
        ? prev.filter((key) => key !== phaseKey)
        : [...prev, phaseKey]
    );
  };

  const debouncedMoauseOver = useDebouncedCallback(async (value: string) => {
    sslog(`preFirst side bar useDebouncedCallback:`, {selectedPath, mouseOverPath, value});  // #gongzhonghao, #xiaohongshu
    setMouseOverPath(value);   // 就是切换项目空间的因子，原先两个 sidebar 的第一个的 Item 光标移动到时，就不断切换第二个bar的列表内容
    if ('#history' === value) {
      if (mouseOverPath === value) {
          setMouseOverPath(selectedPath);
      } else {
          setSelectedPath(mouseOverPath); // 作为点击 #History之前的记忆
          setMouseOverPath(value);
      }
    }

    // setOpen(false);
    // setAnimate(true);
  }, 300);

  // const filteredDocs = memoData.docs;

  return (
    <Sidebar className=" group-data-[side=left]:border-r-0">
      <SidebarHeader>
        <SidebarMenu>
          <div className="flex flex-row justify-between items-center">
            {/* <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  type="button"
                  className="p-1 h-fit"
                  onClick={() => {
                    setOpenMobile(false);
                    router.push('/');
                    router.refresh();
                  }}
                >
                  <PlusIcon />
                </Button>
              </TooltipTrigger>
              <TooltipContent align="end">New Inspire</TooltipContent>
            </Tooltip> */}

            <FloatingActionAddChat onSelect={(link) => {
              console.log('FloatingActionAddChat - onSelect:',  link.href);
              if (link?.href) {
                // debouncedMoauseOver(link.href);
                setCurrentLink(link); // 只设置 setCurrentLink 时，还不会真去切换项目空间的流程列表，只是在中间选择器（ChatNavSelector）上覆盖一层红色显目的遮罩，点击这层遮罩后才真去切换项目空间流程
                // setMouseOverPath(mouseOverPath);
                // setToolActionName(link.value) // 只在切换项目空间时，才调用setToolActionName，以便templateView显示该项目领域的工作流模板template
                sslog('work-sidebar.pathname:', pathname);

                // closePanel()
              }
            }} />

            {/* <div
              className={cn(
                `px-0 p-1 w-[200px]   `, // https://www.tongyi.com/?sessionId=2d67a6370ac2452d8db57270969b6962
              )}
            > */}
            <ChatFlowNavSelector 
              spaceTag={spaceTag}
              onSelect={(link) => {
                console.log('ChatFlowNavSelector - ToolSidebar:',  link);
                if (link?.href.length < 3) return;

                setCurrentLink(link); 
                const {title, label, href } = link;
                const flowTemplateName = `${href.slice(1)}${KEY_FlowTemplateFlag}`;
                setActiveToolItem({label:label.slice(1), phaseKey: href.slice(1), name:KEY_FlowTemplateFlag.slice(1), shortName:'workflow.template', value: flowTemplateName, description: title});
                
                localStorage.setItem(KEY_FlowTemplateFlag, flowTemplateName);
                setFlowTemplateName(flowTemplateName);
                setToolActionName(flowTemplateName); // 允许切换项目空间时，调用setToolActionName，
                // 以便templateView显示该项目领域的工作流模板template，给用户更多查看编辑 workflow模板的机会。
                debouncedMoauseOver(link.href); //真去切换项目空间流程
              }}
              defaultHref={showCurrentLink?.href}
              // defaultHref={mouseOverPath}
              className="group/modal-btn flexShrink: 0" 
              chatId={""}
            />

              {/* <SideBarButtonsGroup onSelect={props.onSelect} className="group/modal-btn flexShrink: 0"/> */}
            {/* </div> */}

            {/* <Link
              href="/"
              onClick={() => {
                setOpenMobile(false);
              }}
              className="flex flex-row gap-3 items-center"
            >
              <span className="text-lg font-semibold px-2 hover:bg-muted rounded-md cursor-pointer">
                
              </span>
            </Link> */}

            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  type="button"
                  className="p-1 h-fit expand-trigger"
                  onClick={() => {
                    debouncedMoauseOver('#history')
                    // setOpenMobile(false);
                    // router.push('/');
                    // router.refresh();
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  {mouseOverPath !== '#history' ? <History size={16}/> : <Flower2 />}
                </Button>
              </TooltipTrigger>
              <TooltipContent align="end">{mouseOverPath !== '#history' ? '会话历史' : '工作流'}</TooltipContent>
            </Tooltip>
          </div>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        {/* <SidebarHistory user={user} /> */}

        <div className="flex flex-col h-full">
          {/* <div className="shrink-0 sticky top-0 z-0 bg-inherit">
            {open ? <Logo /> : <LogoIcon />}
          </div> */}
           <div className="flex-1 overflow-y-auto left-0 ">
            <CMDKWrapper key="raycast">
            {/* <Command value={value} onValueChange={(v) => setValue(v)}> */}
            <Command value={value} >  

              <div cmdk-raycast-top-shine="mmmmmmmm" />
              <Command.Input onValueChange={(v)=>{setSearchValue(v)}}
                //   className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
                // className="h-9 w-full rounded-lg border border-zinc-950/10 bg-transparent p-2 text-xs placeholder-zinc-500 focus:outline-none"
                className="h-9 w-full rounded-lg  bg-transparent p-2 text-xs placeholder-zinc-500 focus:outline-none"
                //   className="rounded-lg border border-neutral-800 focus:ring-2 focus:ring-teal-500  w-full relative z-10 mt-4  bg-neutral-950 placeholder:text-neutral-700"
                //  className="bg-muted text-md md:text-sm h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring"
                ref={inputRef} autoFocus placeholder="搜索..." 
              />
              <hr cmdk-raycast-loader="ddd" />
              {mouseOverPath === '#history' ?
              <SidebarContent>
                <SidebarHistory user={user} search={searchValue} />
              </SidebarContent> : 
              
              <Command.List ref={listRef}>
                {/* <Command.Empty>No results found.</Command.Empty> */}
                {/* <Command.Group className="w-20 text-muted-foreground font-bold font-14 text-sm mt-4" heading="导航">

                </Command.Group> */}
                <Command.Group className="w-fit text-muted-foreground font-semibold font-14 text-sm mt-2" heading="">
                  {memoData.docs.map((group) => {
                    const isOpenGroup = openGroups.includes(group.phaseKey);
                    return (
                    <Collapsible
                      key={group.phaseKey}
                      open={isOpenGroup}
                      onOpenChange={() => toggleGroup(group.phaseKey)}
                    >
                      <CollapsibleTrigger key={group.phaseKey + 'Trigger'} asChild>
                      {open && 
                      <div className={`flex grow flex-col gap-0 ${sideMode === 'Nav' ? 'mt-2 ': 'mt-0'}`}>
                        <Button
                          variant= {sideMode ==='Nav' ? 'ghost' : "secondary"}
                          // className="w-full bg-red-900 h-8 justify-between font-semibold mb-0"
                          className={cn('flex flex-row w-full text-primary/90  border-r-1 border-radius-10% h-8 px-4 text-sm justify-between font-semibold mb-0', {
                            'text-orange-700/70 dark:text-orange-400/70': group.phaseKey === selectedGroup?.phaseKey,
                          })}
                          onClick={()=>{
                            sslog('==============group.phaseKey:', {selectedGroupphaseKey: selectedGroup?.phaseKey, phaseKey:group.phaseKey, group});
                            // if (link?.href.length < 3) return;

                            // setCurrentLink(link); 
                            // const {title, label, href } = ;
                            const {phaseTitle:label, phaseDescription:title, phaseKey} = group;
                            setSelectedGroup(group);
                            const phaseValue = `${phaseKey}.template`;
                            setSelectPath(phaseValue);

                            const flowTemplateName = `${showCurrentLink?.href.slice(1)}@${phaseKey}.template`;
                            setActiveToolItem({label:label, phaseKey, name:KEY_FlowTemplateFlag.slice(1), shortName:'workflow.template', value: flowTemplateName, description: title});

                          }}
                        >
                          {isEn ? group.phaseKey : group.phaseTitle}
                          {isOpenGroup ? (
                             <ChevronDown className="h-4 w-4" onClick={(e)=>{e.stopPropagation();e.preventDefault()}}/>
                          ) : (
                            <ChevronRight className="h-4 w-4" onClick={(e)=>{e.stopPropagation();e.preventDefault()}}/>
                          )}
                           {/* <Checkbox /> */}
                          {/* <div className="text-2xl px-0.5 border-r border-red-200 dark:border-red-700">.</div> */}
                        </Button>
                      </div>}

                      </CollapsibleTrigger>
                      <CollapsibleContent key={group.phaseKey + 'content'}  className={`w-full ${sideMode === 'Nav' ? 'space-y-1': 'space-y-0'} ml-4 mb-0 mt-0  dark:text-gray-400`}>
                        {group.phaseTasks.map((child, index) => (
                        <div key={index + 'wrap'}>
                          {index === 0 && 
                            <div key={index+ 'div'} className="flex flex-wrap w-full h-2 mt-0">
                              {/* mt-auto 会将此部分推到卡片底部 */}
                              {sideMode === 'Step' &&  
                              // <div className="ml-auto pr-1 pl-1 border-l border-gray-200 dark:border-slate-700">
                              <div className="flex ml-auto item-center">  
                                {/* {sideMode === 'Step' && <span className="text-3xs px-0.5">已完成</span>} */}
                                <div className="text-base px-0.5 border-l border-gray-200 dark:border-slate-700"></div>
                                {/* <div className="pr-1 pl-1 border-l border-gray-200 dark:border-slate-700"/> */}
                                <Checkbox className="opacity-0" />
                              </div>}
                            </div>
                          }
                          <div key={index+ 'div1'} className="flex flex-wrap w-full h-7 mt-0">
                          
                            <Item key={child.value} value={child.label}  keywords={['issue', 'sprint']} 
                              onSelect={()=>{  
                                console.log('ToolSidebar select:', child); 
                                // setSpaceTag(child.value); 
                                setSelectedGroup(group);
                                setSelectPath(child.value);
                                setActiveToolItem({...child, phaseKey: group.phaseKey, value:`${mouseOverPath.slice(1)}@${child.value}`});
                                // setToolActionName(child.value) // 只在切换项目空间时，才调用setToolActionName，以便templateView显示该项目领域的工作流模板template
                                
                                // setOpen(false);   // 打开后， 点选某子项时group title会消失；光标从右侧移除时，group title又出现；注释以便取消 group title 变化动效
                              }}>
                              
                              <SidebarLinkNoHref key={child.value}
                                link={{
                                  isActive: child.value === selectPath,
                                  label:isEn ? child.name : child.label,
                                  href: '#',
                                  // icon: null,
                                  icon:(<IconArrowRight 
                                    // className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" 
                                    className=" text-orange-700/80 dark:text-orange-400 size-4 shrink-0" 
                                  />)
                                }}
                              />

                            </Item>
                            {/* mt-auto 会将此部分推到卡片底部 */}
                            {sideMode === 'Step' &&  
                            // <div className="ml-auto pr-1 pl-1 border-l border-gray-200 dark:border-slate-700">
                            <div className="flex ml-auto item-center">  
                              {sideMode === 'Step' && <span className="text-3xs px-0.5">已完成</span>}
                              <div className="text-base px-0.5 border-l border-gray-200 dark:border-slate-700"></div>
                              {/* <div className="pr-1 pl-1 border-l border-gray-200 dark:border-slate-700"/> */}
                              <Checkbox  />
                            </div>}
                          </div>
                        </div>
                        ))}
                      </CollapsibleContent>
                    </Collapsible>
                  )}
                  )}
                </Command.Group>
              </Command.List>}
            </Command>
            </CMDKWrapper>
            </div>
        </div>
      </SidebarContent>
      <SidebarFooter>{user && <SidebarUserNav user={user} 
        onSettings={()=>{
          return;

          console.log('SidebarUserNav - SettingNavLink:',  SettingNavLink);
          const {title, label, href } = SettingNavLink;
          const flowTemplateName = `${href.slice(1)}${KEY_FlowTemplateFlag}`;
          setActiveToolItem({label, phaseKey: href.slice(1), name:KEY_FlowTemplateFlag.slice(1), shortName:'workflow.template', value: flowTemplateName, description: title});
          localStorage.setItem(KEY_FlowTemplateFlag, flowTemplateName);
          setCurrentLink(SettingNavLink); 
          setFlowTemplateName(flowTemplateName);
          setToolActionName(flowTemplateName); // 允许切换项目空间时，调用setToolActionName，
          // 以便templateView显示该项目领域的工作流模板template，给用户更多查看编辑 workflow模板的机会。
          debouncedMoauseOver(SettingNavLink.href); //真去切换项目空间流程

        }}
      />}</SidebarFooter>
    </Sidebar>
  );
}
